import { render, staticRenderFns } from "./character_counter.vue?vue&type=template&id=470bfc88&"
import script from "./character_counter.vue?vue&type=script&lang=js&"
export * from "./character_counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports